import React from 'react'
import Router from './Router'
import './components/@vuexy/rippleButton/RippleButton'

import 'react-perfect-scrollbar/dist/css/styles.css'
import 'react-phone-number-input/style.css'
import 'prismjs/themes/prism-tomorrow.css'
import 'flatpickr/dist/themes/light.css'
import 'rc-slider/assets/index.css'
import './assets/scss/plugins/extensions/dropzone.scss'
import './assets/scss/plugins/forms/flatpickr/flatpickr.scss'
import './assets/scss/plugins/extensions/react-paginate.scss'
import './assets/scss/pages/data-list.scss'

const App = () => {
  return <Router />
}

export default App
